import { getFullUrl } from "../../../../utils/helper";
import { SectionItemProps } from "../../types";

const SectionItem = ({ url, title, description }: SectionItemProps) => {
  return (
    <div
      className="card flex flex-col  justify-center items-start gap-[8px] max-w-[270px] min-h-[143px] p-[12px] max-md:min-w-[48%] max-md:min-h-[141px] max-md:gap-[4px]"
    >
      <img
        src={getFullUrl(url)}
        alt={title}
        width={40}
        height={40}
        loading="lazy"
        decoding="async"
        className="h-[40px] w-[40px] object-contain max-md:h-[32px] max-md:w-[32px]"
      />
      <div className={`text-[16px] font-medium text-[#1A1A1A] line-clamp-2 max-md:text-[14px] leading-tight break-word`}>{title}</div>
      <div className={`text-[14px] font-normal text-[#666666] line-clamp-3 max-md:text-[12px] leading-tight break-word`}>{description}</div>
    </div>
  );
};

export default SectionItem;